import { styled, withTheme } from '@vebox/etui-system';
import { mediaMax } from '../utilities/responsive.js';
import '../utilities/format-ms.js';
import '../utilities/create-transition.js';
import { createElement, Fragment } from 'react';
import '../utilities/get-styleprop.js';
import { _ as _objectWithoutProperties, a as _objectSpread2, b as _extends } from '../_rollupPluginBabelHelpers-3b7bd988.js';
import { Div, P } from '@vebox/etui-system-elements';
import '../Svg-0180d7b5.js';
import Icon from '../Icon/Icon.js';
import '@vebox/etui-icons';
import { icons } from '../Icon/icons.js';
import '../Icon/helper.js';
import { fade } from '@vebox/etui-colors';
import '../ClickOutside/ClickOutside.js';
import '../Tooltip/Tooltip.js';
import Button from '../Button/Button.js';
import { H4 } from '../H4/H4.js';

const _excluded = ["compactView", "showCloseButton", "theme"];
const ModalHeaderDiv = styled(Div).attrs(_ref => {
  let {
      compactView,
      showCloseButton,
      theme
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  return _objectSpread2({
    display: compactView ? 'flex' : ['flex', 'block'],
    position: 'relative',
    p: showCloseButton ? `${theme.spacing.xs}px ${theme.spacing.xlg + 2 * theme.spacing.xs}px` : `${theme.spacing.xs}px`,
    bg: fade(theme.palette.primary.main, 0.1),
    textAlign: compactView ? 'left' : ['left', 'center']
  }, rest);
})``;

const ModalHeaderTitleDiv = styled(Div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  ${({
  theme
}) => mediaMax(theme).xs`
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  `};
`;

const ModalHeader = ({
  title,
  description,
  icon,
  iconColor,
  styles = {},
  onClose,
  showCloseButton = true,
  compactView,
  children,
  theme: {
    palette,
    spacing
  }
}) => {
  var _styles$header, _styles$header2;
  return /*#__PURE__*/createElement(ModalHeaderDiv, _extends({
    compactView: compactView,
    showCloseButton: showCloseButton
  }, styles.root), showCloseButton && /*#__PURE__*/createElement(Div, {
    position: "absolute",
    top: "0",
    right: "0"
  }, /*#__PURE__*/createElement(Button, {
    iconProps: {
      glyph: icons.CLOSE
    },
    variant: "tertiary",
    onClick: onClose,
    p: `${spacing.xs}px`
  })), children || /*#__PURE__*/createElement(Fragment, null, icon && /*#__PURE__*/createElement(Div, {
    color: iconColor || palette.action.disabled,
    mr: spacing.sm
  }, /*#__PURE__*/createElement(Icon, {
    size: (icon === null || icon === void 0 ? void 0 : icon.size) || 24,
    glyph: icon.glyph
  })), /*#__PURE__*/createElement(ModalHeaderTitleDiv, null, /*#__PURE__*/createElement(H4, (_styles$header = styles.header) === null || _styles$header === void 0 ? void 0 : _styles$header.title, title), description && /*#__PURE__*/createElement(P, (_styles$header2 = styles.header) === null || _styles$header2 === void 0 ? void 0 : _styles$header2.description, description))));
};
var ModalHeader$1 = withTheme(ModalHeader);

export default ModalHeader$1;
